<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useDisplay } from 'vuetify'
import { useCustomizerStore } from '@/stores/customizer'
import DemoBanner from '@/components/demo/DemoBanner.vue'
import VerticalSidebar from '../components/VerticalSidebar.vue'
import VerticalHeader from '../components/VerticalHeader.vue'

const customizer = useCustomizerStore()
const { mobile } = useDisplay()

// Sidebar_drawer defaults to true (permanent sidebar on desktop). On mobile
// the same drawer renders as a temporary full-screen overlay, so without
// this it opens on top of the page on every first load.
onMounted(() => {
  if (mobile.value) {
    customizer.Sidebar_drawer = false
  }
})
</script>

<template>
  <v-app
    :theme="customizer.actTheme"
    class="bg-containerBg"
    :class="[
      customizer.actTheme,
      customizer.mini_sidebar ? 'mini-sidebar' : '',
      'verticalLayout',
      customizer.setBorderCard ? 'cardBordered' : '',
    ]"
    :rtl="customizer.setRTLLayout"
  >
    <VerticalSidebar />
    <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
      <VerticalHeader />
    </div>

    <v-main class="ml-md-4">
      <div class="mb-3 hr-layout bg-containerBg">
        <v-container
          fluid
          class="page-wrapper bg-background pt-md-8 rounded-xl"
        >
          <div>
            <div :class="customizer.boxed ? 'maxWidth' : ''">
              <DemoBanner />
              <RouterView />
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

